import { Component } from '@angular/core';

@Component({
  selector: 'smoke-icon',
  standalone: true,
  imports: [],
  templateUrl: './smoke.component.html',
  styleUrl: './smoke.component.scss'
})
export class SmokeIcon {

}
